import { EParcelType } from "dto/EParcelType";
import { ItemKind } from "dto/IKindItems";

export const getItemKindName = (kind: ItemKind) => {
  switch (kind) {
    case ItemKind.EDeliveryMessage:
      return "E-doręczenie";
    case ItemKind.CourtPortalDocument:
    case ItemKind.CourtPortalDeliveranceDocument:
      return "Dokument PI";
    case ItemKind.CourtPortalDeliverance:
      return "Doręczenie PI";
    case ItemKind.CourtPortalApplication:
      return "Wniosek PI";
    case ItemKind.Parcel:
      return "Przesyłka papierowa";
    case ItemKind.CaseFile:
      return "Plik";
    case ItemKind.Email:
      return "E-mail";
    case ItemKind.EditorDocument:
      return "Dokument";
    case ItemKind.ContactMessage:
      return "Przesyłka poufna";
    case ItemKind.OutgoingParcel:
      return "Przesyłka Noty";
    case ItemKind.GovEDeliveryMessage:
      return "e-Doręczenie (urzędowe)";
    case ItemKind.EpuapMessage:
      return "ePUAP";
  }

  return "";
};

export const getParcelTypeName = (kind: EParcelType) => {
  switch (kind) {
    case EParcelType.EDelivery:
    case EParcelType.EncryptedEDelivery:
      return "E-doręczenie";
    case EParcelType.ExternalEDelivery:
      return "e-Doręczenie (urzędowe)";
    case EParcelType.Puh:
      return "e-Doręczenia hybrydowe (PUH)";
    case EParcelType.Epuap:
      return "ePUAP";
    case EParcelType.Ebi:
      return "EBI";
    case EParcelType.Email:
      return "E-mail";
    case EParcelType.NotaEncrypted:
      return "Przesyłka Noty";
    case EParcelType.TraditionalLetter:
      return "List";
    case EParcelType.ContactMessage:
      return "Przesyłka szyfrowana";
  }

  return "";
};
